







import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    title: String
  },

  setup(props) {
    const hasTitle = computed(
      () => props.title != null && props.title != undefined
    )

    return {
      hasTitle
    }
  }
})
